/*
 * Module for handling localized and default category name
 */

define(["marionette", "messaging/messenger", "./categoryDescriptionView"], function (
  Marionette,
  Messenger,
  CategoryDescriptionView,
) {
  var CategoryDescriptionController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "categoryDescription";
      this.region = options.region;
    },
    show: function (category) {
      this.category = category;
      this.view = new CategoryDescriptionView.categoryDescriptionView({ model: this.category });
      this.showRegion(this.view);
    },
  });

  return CategoryDescriptionController;
});
